// extracted by mini-css-extract-plugin
export default {"ordersCard":"InstallOrder_ordersCard__Vtw60","orders":"InstallOrder_orders__RvQBR","seven":"InstallOrder_seven__DgmiU","ten":"InstallOrder_ten__35bM2"};